import config from 'config';
import camelize from 'lodash/camelCase';

import { ProductCategory } from '~/shared/constants/products';
import { isSavage } from '~/shared/utils/brandNameHelper';
import { MODEL_SIZES_MAP } from '~/shared/utils/sizeConstants';

export default function useModelSizeLabel({
  model,
  sizeCategory,
  productCategoryIdList,
  tagIdList,
}) {
  const currentModelSizeKey = MODEL_SIZES_MAP[camelize(sizeCategory)]?.key;
  const currentModelSize = (model?.[currentModelSizeKey] || '').toUpperCase();
  let waistInseamSize;

  const isProductSXFBralette = productCategoryIdList?.includes(
    ProductCategory.bralette
  );

  // savage bra display(not bralette) is cup/band size
  if (
    isSavage() &&
    currentModelSizeKey === MODEL_SIZES_MAP.sizeBra.key &&
    !isProductSXFBralette
  ) {
    return model?.cupSize && model?.bandSize
      ? `${model.bandSize}${model.cupSize.toUpperCase()}`
      : null;
  }

  // waist and inseam size
  if (model && currentModelSizeKey === MODEL_SIZES_MAP.sizeBottom.key) {
    const currentModelWaist = model[MODEL_SIZES_MAP.sizeWaist.key];
    const currentModelInseam = model[MODEL_SIZES_MAP.inseamLength.key];

    if (currentModelWaist) {
      waistInseamSize = `${currentModelWaist}`;
    }

    if (currentModelInseam) {
      waistInseamSize = waistInseamSize?.length
        ? `${waistInseamSize} x ${currentModelInseam}`
        : `${currentModelInseam}`;
    }
  }

  const onePieceModelSize = (
    model?.bottomSize ||
    model?.topSize ||
    '-'
  ).toUpperCase();

  const isProductOnePiece = productCategoryIdList?.includes(
    ProductCategory.dresses
  );
  const isProductUnderwear = productCategoryIdList?.includes(
    ProductCategory.underwear
  );

  const waistInseamDisplayTagId = config.get(
    'public.productTags.waistInseamDisplay'
  );
  const isTaggedWaistInseam = tagIdList.find(
    (tagId) => waistInseamDisplayTagId === tagId
  );

  let displaySize =
    isProductOnePiece || isProductUnderwear
      ? onePieceModelSize
      : currentModelSize;

  displaySize =
    isTaggedWaistInseam && waistInseamSize ? waistInseamSize : displaySize;

  return displaySize;
}
